import { render, staticRenderFns } from "./work.vue?vue&type=template&id=62d88b50&scoped=true&"
import script from "./work.vue?vue&type=script&lang=js&"
export * from "./work.vue?vue&type=script&lang=js&"
import style0 from "./work.vue?vue&type=style&index=0&id=62d88b50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d88b50",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62d88b50')) {
      api.createRecord('62d88b50', component.options)
    } else {
      api.reload('62d88b50', component.options)
    }
    module.hot.accept("./work.vue?vue&type=template&id=62d88b50&scoped=true&", function () {
      api.rerender('62d88b50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/customChildren/work.vue"
export default component.exports